import script from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsFixtureBook.vue?vue&type=style&index=0&id=824d8c52&scoped=true&lang=css"
import "./LiveSportsFixtureBook.vue?vue&type=style&index=1&id=824d8c52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824d8c52"]])

export default __exports__